import { CheckCircle2, MessageSquareQuote, MessageCircle, Lightbulb, ScanEye, AlertTriangle } from 'lucide-react';
import { useI18n } from '../lib/i18n';

const MAP = {
  verified_fact: { color: '#10B981', bg: 'rgba(16,185,129,0.10)', Icon: CheckCircle2 },
  testimonial: { color: '#3B82F6', bg: 'rgba(59,130,246,0.10)', Icon: MessageSquareQuote },
  opinion: { color: '#64748B', bg: 'rgba(100,116,139,0.10)', Icon: MessageCircle },
  hypothesis: { color: '#8B5CF6', bg: 'rgba(139,92,246,0.10)', Icon: Lightbulb },
  interpretation: { color: '#0EA5E9', bg: 'rgba(14,165,233,0.10)', Icon: ScanEye },
  unverified_data: { color: '#F59E0B', bg: 'rgba(245,158,11,0.12)', Icon: AlertTriangle },
};

export function ReliabilityBadge({ level, size = 'sm' }) {
  const { t } = useI18n();
  const cfg = MAP[level] || MAP.opinion;
  const label = t.reliability[level] || level;
  const px = size === 'lg' ? 'px-3.5 py-1.5 text-sm' : 'px-2.5 py-1 text-xs';
  const iconSize = size === 'lg' ? 16 : 13;
  return (
    <span
      data-testid={`reliability-badge-${level}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${px}`}
      style={{ color: cfg.color, backgroundColor: cfg.bg }}
    >
      <cfg.Icon size={iconSize} strokeWidth={2} />
      {label}
    </span>
  );
}
